var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserIcon = function SvgUserIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_100894)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F33A9E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_467_100894)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06173 10.6875C8.06173 9.64321 8.47657 8.64169 9.215 7.90327C9.95342 7.16484 10.9549 6.75 11.9992 6.75C13.0435 6.75 14.045 7.16484 14.7835 7.90327C15.5219 8.64169 15.9367 9.64321 15.9367 10.6875C15.9367 11.7318 15.5219 12.7333 14.7835 13.4717C14.045 14.2102 13.0435 14.625 11.9992 14.625C10.9549 14.625 9.95342 14.2102 9.215 13.4717C8.47657 12.7333 8.06173 11.7318 8.06173 10.6875ZM4.78135 23.0294C4.81086 21.1345 5.58429 19.3273 6.9347 17.9978C8.2851 16.6682 10.1042 15.923 11.9992 15.923C13.8943 15.923 15.7134 16.6682 17.0638 17.9978C18.4142 19.3273 19.1876 21.1345 19.2171 23.0294C19.2194 23.1569 19.1844 23.2824 19.1165 23.3904C19.0486 23.4984 18.9507 23.5843 18.8347 23.6375C16.6903 24.6207 14.3584 25.1282 11.9992 25.125C9.56148 25.125 7.24535 24.593 5.16373 23.6375C5.04778 23.5843 4.94986 23.4984 4.88195 23.3904C4.81403 23.2824 4.77908 23.1569 4.78135 23.0294Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_100894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_467_100894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(1.5 4.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user-icon.623f5865218d3231265a402a376b1219.svg";